module.exports = __webpack_public_path__ + "assets/7f17ba901f8c1505688aa8b7ffbaa0a7.mp3";